
import Select from './Select'

export const STATUSES = [
  { id: 'all', name: 'Fulfillment: all' },
  { id: 'true', name: 'Fulfilled' },
  { id: 'false', name: 'Unfulfilled' },
]

export default function OrderStatusSelect(props) {
  return <Select allowClear={false} {...props} options={STATUSES} />
}
